import moment from 'moment'
import { Moment } from 'moment'

export const determineCalendarStartDate = (currentDate: Moment | string | Date): Moment => {
  const startDateOfWeek = moment(currentDate).startOf('week')

  if (moment(currentDate).isoWeekday() == 6) {
    // Saturday → bump to next week so calendar always opens on a Monday-ish view
    startDateOfWeek.add(1, 'week')
  }

  return startDateOfWeek
}
